import {Component, inject} from "@angular/core";
import {MarkdownModule} from "ngx-markdown";
import {Store} from "@ngrx/store";
import {Title} from "@angular/platform-browser";
import {legalFeature} from "../../../state/legal.state";

@Component({
  selector: "acceptable-use-policy",
  standalone: true,
  imports: [MarkdownModule],
  templateUrl: "./acceptable-use-policy.component.html",
  styleUrl: "./acceptable-use-policy.component.scss",
})
export class AcceptableUsePolicyComponent {
  version = inject(Store).selectSignal(legalFeature.selectTermsVersion);
  constructor(private titleService: Title) {
    this.titleService.setTitle("Acceptable Use Policy - Symbiot AI");
  }
}
